import React from 'react'

export const CollectionsContext = React.createContext(null);

export default CollectionsContext;
